module.exports = __webpack_public_path__ + "img/bg.c77ab66e.jpg";